
export const GetAuthCode = () => {
    const urlParams = new URLSearchParams(window.location.search);
    return urlParams.get('code');
}

export const IsInEditMode = () => {
    return GetAuthCode() !== null
}